import api from 'src/config/api'

export const getRank = function ({commit}, payload) {

  return new Promise((resolve, reject)=> {

    let url = api.endpoints.getRank
    if (!payload.time) return reject()
    url += `?time=${Math.round(payload.time)}`
    if (payload.name) url += `&name=${payload.name}`
    fetch(url)
      .then((response)=> {
        return response.json()
      })
      .then((json)=> {
        commit('setRanking', json.ranking)
        resolve()
      })

  })

}




// WEBPACK FOOTER //
// ./src/store/game/actions.js